import { SYSTEM_ERROR } from "../../src/config/CONSTANT";
import axios from "axios";
import packageJson from "../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const getContact = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(
          `${BaseUrl}/api/contact`,
          {
            withCredentials: true,
          }
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getAllTrips axios!");
        });
    } catch (error) {
      console.error("in tripServices > getAllTrips, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};
